import 'video-react/dist/video-react.css';
import { Tag } from '../../../interfaces';
import { humanizeEnum } from '../../../utils';
import { EventTagDropdownOption } from './interfaces';

export const prepareListOfDropdownOptions = (questions: Tag[]): EventTagDropdownOption[] => {
  const optionList: EventTagDropdownOption[] = [];

  questions.forEach((tag) => {
    const path = tag.id.toString();
    // not using destructuring here because TS gets all confused on type assertions
    if (tag.value_type === 'bool') {
      tag.enum_variants?.forEach(() => {
        optionList.push({
          tag,
          name: `${humanizeEnum(tag.name)}: true`,
          path,
          value: true,
        });

        optionList.push({
          tag,
          name: `${humanizeEnum(tag.name)}: false`,
          path,
          value: false,
        });
      });
    }

    if (tag.value_type === 'int') {
      optionList.push({
        tag,
        name: `${tag.name} (${tag.min_value} - ${tag.max_value})`,
        path,
        value: 'prompt',
      });
    }

    if (tag.value_type === 'enum') {
      // FIXME add multi selection if we ever want it
      tag.enum_variants?.forEach((value) => {
        optionList.push({
          tag,
          path,
          name: `${tag.name}: ${humanizeEnum(value.variant_name)}`,
          value: value.id,
        });
      });
    }
  });

  return optionList;
};
